const menu = require("../../../../../components/menu/menu");
const dtHandler = require("../../../../../components/dt/dt-handler");

export function start(detail, htmlDt, htmlFc) {
  //console.log('Menu Type 2 -> ', detail)

  const menuElem = menuBody[detail.id];

  for (let i = 0; i < menuElem.length; i++) {
    menuElem[i].start(detail, htmlDt, htmlFc);
  }

  detail.html = menuElem;

  detail.act = "show";
  menu.start(detail);
}

const menuBody = {
  trMenu: [
    {
      text: "",
      svg: "eye",
      class: ``,
      dataDetail: ``,

      start: function (detail) {
        this.text = "View"; //language.start('inProgress')
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              { "dest":"accountsPayable", "elem":"fullcont", "id":"accountsPayable-fullcont", "act":"callData", "dbid": ${detail.dbid} },
                               {"dest":"accountsPayable", "elem":"fullcont", "id":"accountsPayable-fullcont", "act":"callUnpaidInvoices", "dbid": ${detail.dbid}}
           ]}'`;
      },
    },
  ],

  tableOptions: [
    {
      text: "",
      svg: "print",
      class: ``, //same name as the title test

      dataDetail: "",

      start: function (detail) {
        this.text = "Print All Accounts Payable"; //language.start('inProgress')
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"accountsPayable", "elem":"fullcont", "act":"printReportAll" }

        ]}'`;
      },
    },
  ],

  fullcontOptions: [
    {
      text: "",
      svg: "print",
      class: ``, //same name as the title test
      dataDetail: ``,

      start: function (detail, htmlDt, htmlFc) {
        const dbid = htmlFc.fullcontHTML.getAttribute("data-dbid");

        //if exist one check
        this.class = ``;
        this.text = `Print Accounts Payable`;
        this.dataDetail = `data-detail='{
                                     "click": [
                                        {"dest":"ripple" },
                                        {"dest":"menu", "act":"hide"},
                                        {"dest":"accountsPayable", "elem":"fullcont", "act":"printReportOne"} ]}'`;
      } /**/,
    },
  ],
}; /*menuBody*/
